import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-c09d4c3c")

_pushScopeId("data-v-c09d4c3c")
const _hoisted_1 = {
  class: "modal fade",
  id: "product_to_warehouses",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  "aria-labelledby": "staticBackdropLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = {
  class: "modal-header",
  id: "kt_modal_new_address_header"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("div", {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}, [
  /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-1" }, [
    /*#__PURE__*/_createVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_5 = { class: "card" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InnerLoader = _resolveComponent("InnerLoader")!
  const _component_Table = _resolveComponent("Table")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_InnerLoader, {
      loading: _ctx.loading,
      innerLoading: true
    }, null, 8, ["loading"]),
    _createVNode("div", {
      class: ['modal-dialog modal-dialog-centered', _ctx.wmsManagesProducts ? 'mw-900px' : 'mw-650px']
    }, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("h2", null, _toDisplayString(_ctx.$t('message.PRODUCT_TO_WAREHOUSES')), 1),
          _hoisted_4
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_Table, {
            columns: _ctx.columns,
            rows: _ctx.warehouses_data,
            padding: 5,
            loading: _ctx.loader
          }, {
            "cell-no": _withId(({index:index}) => [
              _createTextVNode(_toDisplayString(index + 1), 1)
            ]),
            _: 1
          }, 8, ["columns", "rows", "loading"])
        ])
      ])
    ], 2)
  ]))
})